import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { Loading } from 'element-ui';
import { assess } from "@api/login";
import util from '@/libs/util.js';
import dayjs from 'dayjs';
import { mapActions } from 'vuex';
import localeMixin from '@/locales/mixin.js';
export default {
  mixins: [localeMixin],
  computed: _objectSpread({}, mapActions('d2admin/page', ['closeAll'])),
  data: function data() {
    return {
      redirect: undefined,
      timeInterval: null,
      time: dayjs().format('HH:mm:ss'),
      // 快速选择用户
      dialogVisible: false,
      users: [{
        name: 'Admin',
        username: 'admin',
        password: 'admin'
      }, {
        name: 'Editor',
        username: 'editor',
        password: 'editor'
      }, {
        name: 'User1',
        username: 'user1',
        password: 'user1'
      }],
      // 表单
      formLogin: {
        username: 'admin',
        password: 'admin',
        code: 'v9am'
      },
      // 表单校验
      rules: {
        username: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }]
      },
      loadingInstance: null
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.timeInterval = setInterval(function () {
      _this.refreshTime();
    }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timeInterval);
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/account', ['login'])), {}, {
    refreshTime: function refreshTime() {
      this.time = dayjs().format('HH:mm:ss');
    },
    /**
     * @description 接收选择一个用户快速登录的事件
     * @param {Object} user 用户信息
     */
    handleUserBtnClick: function handleUserBtnClick(user) {
      this.formLogin.username = user.username;
      this.formLogin.password = user.password;
      this.submit();
    },
    /**
     * @description 提交表单
     */
    // 提交登录信息
    submit: function submit() {
      var _this2 = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          // 登录
          // 注意 这里的演示没有传验证码
          // 具体需要传递的数据请自行修改代码
          _this2.login({
            username: _this2.formLogin.username,
            password: _this2.formLogin.password
          }).then(function () {
            // 重定向对象不存在则返回顶层路径
            _this2.$router.replace(_this2.$route.query.redirect || '/');
          });
        } else {
          // 登录表单校验失败
          _this2.$message.error('表单校验失败，请检查');
        }
      });
    },
    initUserInfo: function initUserInfo(data) {
      var _arguments = arguments,
        _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var info, userId, id, userName, tenant;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              info = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {};
              userId = data.userId, id = data.id, userName = data.userName, tenant = data.tenant;
              _this3.login({
                username: userName,
                userId: userId,
                token: id,
                tenant: tenant,
                userInfo: info
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      _context.n = 1;
                      return _this3.$store.commit('cpscc/updateUserInfo', info);
                    case 1:
                      _this3.loading = false;
                      _this3.$message.success('登录成功');
                      // await this.$store.dispatch('cpsca/init', null, { root: true })
                      _this3.$router.replace(_this3.redirect || '/correspondence/task');
                    case 2:
                      return _context.a(2);
                  }
                }, _callee);
              })));
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    assessUser: function assessUser(token, Tenant, admin) {
      var _arguments2 = arguments,
        _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var params, _yield$_this4$$awaitT, _yield$_this4$$awaitT2, err, data, data1, data2, userId, userName;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              params = _arguments2.length > 3 && _arguments2[3] !== undefined ? _arguments2[3] : {};
              _this4.loading = true;
              util.cookies.set('token', token);
              util.cookies.set('tenant', Tenant);
              _context3.n = 1;
              return _this4.$awaitTo(assess({
                token: token,
                Tenant: Tenant,
                admin: admin
              }));
            case 1:
              _yield$_this4$$awaitT = _context3.v;
              _yield$_this4$$awaitT2 = _slicedToArray(_yield$_this4$$awaitT, 2);
              err = _yield$_this4$$awaitT2[0];
              data = _yield$_this4$$awaitT2[1];
              _this4.loadingInstance.close();
              if (!err) {
                _context3.n = 2;
                break;
              }
              _this4.loading = false;
              return _context3.a(2);
            case 2:
              data1 = data.data1, data2 = data.data2;
              _this4.$store.commit('cpscc/updateMenus', data1);
              userId = data2.userId, userName = data2.userName;
              util.cookies.set('tenantId', data2.tenantId);
              _this4.initUserInfo({
                userId: userId,
                id: token,
                userName: data2.userName ? data2.userName : data2.admin ? '管理员' : userName,
                tenant: Tenant
              }, _objectSpread(_objectSpread({}, data), params));
              _this4.$store.dispatch('cpscc/init');
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    toLogin: function toLogin() {
      var type = {
        // 'dev':true,
        test: true
      };
      if (process.env.VUE_APP_ENV === 'pro') {
        // if(location.hostname === "imp.gpcpa.cn"){
        //   window.location.href = `${location.origin}`
        //   return ;
        // }
        window.location.href = "".concat(location.origin);
        return;
      }
      if (type[process.env.VUE_APP_ENV]) {
        window.location.href = process.env.VUE_APP_LOGIN_URL;
      }
    }
  }),
  created: function created() {
    var _this$$route$query = this.$route.query,
      token = _this$$route$query.token,
      Tenant = _this$$route$query.Tenant,
      logo1 = _this$$route$query.logo1,
      logo2 = _this$$route$query.logo2,
      shortName = _this$$route$query.shortName,
      form = _this$$route$query.form,
      redirect = _this$$route$query.redirect;
    var loginAdmin = this.$route.query.admin;
    this.$store.commit('cpscc/updateMenus', undefined);
    this.$store.commit('cpscc/updateUserInfo', undefined);
    if (redirect) {
      this.redirect = redirect;
    }
    if (token && Tenant) {
      this.loadingInstance = Loading.service({
        fullscreen: true,
        text: "\u7CFB\u7EDF\u9996\u6B21\u521D\u59CB\u5316\u65F6\u95F4\u8F83\u957F, \u8BF7\u8010\u5FC3\u7B49\u5F85"
      });
      this.assessUser(token, Tenant, loginAdmin === 'true', {
        logo1: logo1,
        logo2: logo2,
        shortName: shortName,
        form: form
      });
      // this.waiting();
    } else {
      this.toLogin();
    }
  }
};